import React, { } from 'react';
import {  Modal } from 'antd';

interface ModalFormProps {
    modalTitle: string;
    width?: number;
    onOk?: () => void;
    onCancel?: () => void;
    open: boolean;
    Subtitle: string;
    okText: string;
    cancelText: string;
    setOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

const ModalForm: React.FC<ModalFormProps> = ({
    modalTitle,
    onOk,
    onCancel,
    open,
    setOpen,
    Subtitle,
    okText='Approve',
    cancelText='Decline'
}) => {
 
    const handleOk = () => {
        if (onOk) {
            onOk();
        }
        setOpen(false);
    };

    const handleCancel = () => {
        if (onCancel) {
            onCancel();
        }
        setOpen(false);
    };

    return (
        <>
            <Modal
                title={modalTitle}
                centered
                open={open}
                onOk={handleOk}
                onCancel={handleCancel}
                okText={okText}
                cancelText={cancelText}
                okButtonProps={{
                    style: { backgroundColor: '#095179', color: '#ffffff' },
                }}
            >
             {Subtitle}
            </Modal>
        </>
    );
};

export default ModalForm;
